<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    {
      label: 'INTERNATIONALIZATION',
      url: isUpdateMode ? ['../../', 'list'] : ['../', 'list']
    },
    { label: isUpdateMode ? 'UPDATE_TRANSLATION' : 'CREATE_TRANSLATION' }
  ]"
></breadcrumbs>

<page-header
  [title]="isUpdateMode ? 'UPDATE_TRANSLATION' : 'CREATE_TRANSLATION'"
></page-header>

<card>
  <form class="form" (submit)="onSubmit($event)" [formGroup]="form">
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="KEY">{{
        'KEY' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          [formControlName]="'key'"
          type="text"
          [ngClass]="{
            'is-danger': keyControll.touched && keyControll.errors?.required
          }"
        />
      </div>
      <p
        translationEditableDirective="IS_REQUIRED"
        class="help is-danger"
        *ngIf="keyControll.touched && keyControll.errors?.required"
      >
        {{ 'IS_REQUIRED' | translate }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="VALUE">{{
        'VALUE' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          [formControlName]="'value'"
          type="text"
          [ngClass]="{
            'is-danger': valueControll.touched && valueControll.errors?.required
          }"
        />
      </div>
      <p
        translationEditableDirective="IS_REQUIRED"
        class="help is-danger"
        *ngIf="valueControll.touched && valueControll.errors?.required"
      >
        {{ 'IS_REQUIRED' | translate }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped px-3">
  <div class="control">
    <button
      [disabled]="isLoading || form.invalid || form.pristine"
      type="submit"
      class="button is-success"
      translationEditableDirective="SUBMIT"
      (click)="onSubmit($event)"
    >
      {{ 'SUBMIT' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="isUpdateMode ? ['../../', 'list'] : ['../', 'list']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
    >
      {{ 'CANCEL' | translate }}
    </a>
  </div>
</div>
